import {
  getEntityLabel,
  getTitleBase,
  getCorrectOffSalesRegion,
} from "../util";
import { facebookPixel, facebookPixelNoScript, hotjar } from "./analytics";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import React from "react";

const Head = ({ entity, location }) => {
  const canonical = `${window.location.origin}${location.pathname}${location.search}`;
  return (
    <Helmet>
      {/* Note head logic is duplicated in API repo also */}
      <title>{getTitleBase(entity)}</title>
      <link rel="canonical" href={canonical} />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cloud.typenetwork.com/projects/2843/fontface.css/"
      ></link>
      <meta
        name="description"
        content={`${
          entity.tagline ? `${entity.tagline}. ` : ""
        }View properties for sale from ${
          entity.brand
        } ${getCorrectOffSalesRegion(entity)} real estate ${getEntityLabel(
          entity
        ).toLowerCase()} ${entity.displayName}.`}
      />
      <meta property="og:title" content={getTitleBase(entity)} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={entity.photo && entity.photo.url} />
      <meta property="og:description" content={entity.ogBiography} />
      <script type="text/javascript">
        {hotjar(entity.siteOptions.analytics)}
      </script>
      <script type="text/javascript">
        {facebookPixel(entity.siteOptions.analytics)}
      </script>
      <noscript>{facebookPixelNoScript(entity.siteOptions.analytics)}</noscript>
      {entity.hubSpotEnabled ? (
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="//js.hs-scripts.com/4526877.js"
        ></script>
      ) : (
        <script type="text/javascript" />
      )}
    </Helmet>
  );
};

Head.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default Head;



// WEBPACK FOOTER //
// ./src/components/shared/head/index.js